import type { BasicAuth } from '@/ts/types/basic-auth.type'

export const getBasicAuth: () => BasicAuth | undefined = () => {
  const mode = import.meta.env.MODE
  const username = import.meta.env.VITE_BMF_BASIC_AUTH_USERNAME
  const password = import.meta.env.VITE_BMF_BASIC_AUTH_PASSWORD
  if (mode === 'production' || !username || !password) return
  return { username, password }
}
